<kendo-grid
  #grid
  [data]="view | async"
  [style.height.%]="100"
  [pageable]="{
    buttonCount: buttonCount,
    info: info,
    type: type,
    pageSizes: pageSizes,
    previousNext: previousNext
  }"  
  [pageSize]="gridState.take"
  [skip]="gridState.skip"
  [sort]="gridState.sort"
  [sortable]="false"
  (dataStateChange)="onStateChange($event)"
  (edit)="editHandler($event)"
  [navigable]="true"
  [loading]="loading"
  [resizable]="true">

  <kendo-grid-column
    field="Id"
    title="Id"
    width="52%">
  </kendo-grid-column>

  <kendo-grid-column
    field="EnqueuedAt"
    title="Enqueued (UTC)"
    filter="Date"
    width="34%">
    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
      {{dataItem.EnqueuedAt | date:'short'}}
    </ng-template>    
  </kendo-grid-column>

  <kendo-grid-column
    field="Size"
    title="Size"
    width="10%">
  </kendo-grid-column>  

  <kendo-grid-command-column title="" width="8%">
    <ng-template kendoGridCellTemplate let-dataItem="dataItem">
      <button class="btn btn-primary compact-button" kendoGridEditCommand>
        <fa-icon icon="external-link-alt"></fa-icon>
      </button>
    </ng-template>
  </kendo-grid-command-column>
</kendo-grid>

<app-message 
    [model]="editItem"
    [scope]="scope"
    (cancel)="cancelHandler()"
    (delete)="deleteHandler($event)"
    (resubmit)="resubmitHandler($event)">
</app-message>
